// Copyright (c) 2017 Deere & Company

import Invoice from '@deere/cps-it.warranty-model-factory/lib/invoice';
import t from 'tcomb';

const DealerInvoices = t.list(Invoice, 'DealerInvoices');

export const getDefaultState = () => new DealerInvoices([]);

export default DealerInvoices;



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/state/dealer-invoice-list.js